import { OBtcWalletId, getBitgetBtcProvider } from 'modules/api';
import {
  ConnectBtn,
  IConnectBtnProps,
} from 'modules/auth/components/ConnectBtn';
import { WalletIcon } from 'modules/auth/components/WalletIcon';
import { useBtcConnectBtnAdapter } from 'modules/auth/hooks/useBtcConnectBtnAdapter';
import { useTranslation } from 'modules/i18n';
import { translation } from './translation';

const walletId = OBtcWalletId.Bitget;

export function ConnectBitget({
  iconOnly,
}: Pick<IConnectBtnProps, 'iconOnly'>): JSX.Element {
  const { keys, t } = useTranslation(translation);

  const props = useBtcConnectBtnAdapter({
    walletId,
    isInjected: !!getBitgetBtcProvider(),
  });

  return (
    <ConnectBtn
      {...props}
      iconOnly={iconOnly}
      title={t(keys.title)}
      iconSlot={<WalletIcon wallet={walletId} />}
    />
  );
}
